import BagCheckin from '@ixigo/icons/BagCheckin';
import Person from '@ixigo/icons/Person';
import Typography from '@ixigo/iui/Typography';

export interface CapacityItemProps {
	title: string;
	type: 'PAX' | 'BAGGAGE';
}

const IconMap: Record<CapacityItemProps['type'], React.ReactNode> = {
	PAX: <Person width={15} height={15} />,
	BAGGAGE: <BagCheckin width={15} height={15} />,
};

/**
 * CapacityItem component displays individual capacity information with appropriate icon
 *
 * @param type - Type of capacity ("PAX" for passengers or "BAGGAGE" for luggage)
 * @param title - Description text for the capacity (e.g., "4", "2")
 * @returns JSX element with icon and capacity text
 *
 *
 * Possible errors:
 * - Invalid type values other than "PAX" or "BAGGAGE" will not display an icon
 * - Empty title prop will render an empty text element
 *
 * Exception handling:
 * - IconMap provides fallback for unsupported types (will be undefined)
 * - Component gracefully handles missing icons by rendering empty div
 */
export const CapacityItem = ({ type, title }: CapacityItemProps) => {
	const icon = IconMap[type];

	if (!icon) {
		return null;
	}

	return (
		<div className="flex items-center justify-center">
			<Typography variant="body-sm">{title}</Typography>
			<div className="text-secondary shrink-0 flex items-center">{icon}</div>
		</div>
	);
};
